import { APIClient } from "@surya-digital/tedwig";
import { GetAllowedDomainsRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getAllowedDomainsRPC";
import { GetAllowedDomainsRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getAllowedDomainsRPCClientImpl";
import { AddAllowedDomainRPC } from "@pulse/pulse-rpcs/lib/email-cycle/addAllowedDomainRPC";
import { AddAllowedDomainRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/addAllowedDomainRPCClientImpl";
import { UpdateAllowedDomainRPC } from "@pulse/pulse-rpcs/lib/email-cycle/updateAllowedDomainRPC";
import { UpdateAllowedDomainRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/updateAllowedDomainRPCClientImpl";
import { DeleteAllowedDomainRPC } from "@pulse/pulse-rpcs/lib/email-cycle/deleteAllowedDomainRPC";
import { DeleteAllowedDomainRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/deleteAllowedDomainRPCClientImpl";

export const useGetAllowedDomainsRPCClientImpl = (
  apiClient: APIClient,
): GetAllowedDomainsRPC => new GetAllowedDomainsRPCClientImpl(apiClient);

export const useAddAllowedDomainRPCClientImpl = (
  apiClient: APIClient,
): AddAllowedDomainRPC => new AddAllowedDomainRPCClientImpl(apiClient);

export const useUpdateAllowedDomainRPCClientImpl = (
  apiClient: APIClient,
): UpdateAllowedDomainRPC => new UpdateAllowedDomainRPCClientImpl(apiClient);

export const useDeleteAllowedDomainRPCClientImpl = (
  apiClient: APIClient,
): DeleteAllowedDomainRPC => new DeleteAllowedDomainRPCClientImpl(apiClient);
